const EritreaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111381)">
      <path
        d="M18.2605 18.2598C18.2605 18.2598 5.86914 34.1439 5.85742 34.141C9.47664 37.7603 14.4767 39.9989 19.9996 39.9989C31.0452 39.9989 39.9996 31.0445 39.9996 19.9989L18.2605 18.2598Z"
        fill="#338AF3"
      />
      <path
        d="M18.2605 20C18.2605 20 5.86914 5.85508 5.85742 5.85789C9.47664 2.23859 14.4767 0 19.9996 0C31.0452 0 39.9996 8.95437 39.9996 20H18.2605Z"
        fill="#6DA544"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C5.8573 34.145 40 19.9996 40 19.9996L5.85785 5.85742Z"
        fill="#D80027"
      />
      <path
        d="M10.435 11.7402C6.59914 11.7402 3.47852 14.8609 3.47852 18.6967V21.3054C3.47852 25.1413 6.59922 28.2619 10.435 28.2619C14.2708 28.2619 17.3915 25.1412 17.3915 21.3054V18.6967C17.3916 14.8609 14.2709 11.7402 10.435 11.7402ZM14.7828 21.3055C14.7828 23.2486 13.5014 24.8977 11.7393 25.4531V22.6098L13.5849 20.7642L11.7403 18.9196L11.7393 18.2631V17.3925H9.1307V20.0011L7.28633 21.8454L9.1307 23.6897V25.4532C7.36859 24.8978 6.08719 23.2487 6.08719 21.3055V18.6969C6.08719 16.2995 8.03766 14.3491 10.435 14.3491C12.8323 14.3491 14.7828 16.2995 14.7828 18.6969V21.3055Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111381">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default EritreaSvg;
